import Notification from './Notification';
import React, { FC, ReactElement, useEffect } from 'react';
import { Outlet, useMatch } from 'react-router';
import UpgradeNotification from './UpgradeNotification';
import Footer from './Footer';

const PageLayout: FC = (): ReactElement => {
  const isChatPage: boolean = Boolean(useMatch('/messages'));

  useEffect(() => {
    document.body.classList.toggle('stop-scrolling', isChatPage);
    return (): void => document.body.classList.remove('stop-scrolling');
  }, [isChatPage]);

  return (
    <div className="d-flex flex-column" style={{ height: '100dvh', overflow: 'hidden' }}>
      <Notification />
      <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, overflow: 'auto' }}>
        <Outlet />
      </div>
      <Footer />
      <UpgradeNotification />
    </div>
  );
};

export default PageLayout;
